import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=2e20935a&scoped=true"
import script from "./activityPage.vue?vue&type=script&lang=js"
export * from "./activityPage.vue?vue&type=script&lang=js"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=2e20935a&prod&scoped=true&lang=css"
import style1 from "./activityPage.vue?vue&type=style&index=1&id=2e20935a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20935a",
  null
  
)

export default component.exports